import '../styles/screens.css';

/**
 * Lessons — five clickable lesson cards, each opening a dedicated
 * Netlify-hosted lesson page in a new tab.
 *
 * Thumbnails live in /public/lessons/ and are referenced as
 * static assets so they are bundled with the Vite build.
 */

const LESSONS = [
  {
    id: 1,
    title: 'Speaking, reading & thinking rates',
    thumb: '/lesson_1_rate_of_speech.png',
    url: 'https://profound-monstera-66a01c.netlify.app/',
  },
  {
    id: 2,
    title: 'Start with your objective',
    thumb: '/lesson_2_objectives.png',
    url: 'https://chimerical-khapse-d42f38.netlify.app/',
  },
  {
    id: 3,
    title: 'Design for retention',
    thumb: '/lesson_3_memory.png',
    url: 'https://stellar-praline-90cec4.netlify.app/',
  },
  {
    id: 4,
    title: 'Organise your content',
    thumb: '/lesson_4_organization.png',
    url: 'https://friendly-meringue-ecbbb4.netlify.app/',
  },
  {
    id: 5,
    title: 'Design your visuals',
    thumb: '/lesson_5_visuals.png',
    url: 'https://beamish-axolotl-6ebe35.netlify.app/',
  },
];

export default function Lessons() {
  return (
    <div className="screen">
      <header className="screen-head">
        <div className="screen-head-text">
          <span className="eyebrow">The Presentation Lab</span>
          <h1>
            Your <em>lessons</em>
          </h1>
        </div>
      </header>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
        {LESSONS.map((lesson) => (
          <a
            key={lesson.id}
            href={lesson.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-4)',
              background: 'var(--surface)',
              borderRadius: 'var(--radius-lg)',
              padding: 'var(--space-3)',
              textDecoration: 'none',
              color: 'inherit',
              boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
              transition: 'transform 0.15s ease, box-shadow 0.15s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.13)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.07)';
            }}
          >
            {/* Thumbnail */}
            <div style={{
              flexShrink: 0,
              width: 96,
              height: 72,
              borderRadius: 'var(--radius)',
              overflow: 'hidden',
              background: 'var(--cream)',
            }}>
              <img
                src={lesson.thumb}
                alt={`Lesson ${lesson.id} thumbnail`}
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
            </div>

            {/* Text */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <span className="eyebrow" style={{ color: 'var(--terra)', marginBottom: 4, display: 'block' }}>
                Lesson {lesson.id}
              </span>
              <p style={{
                margin: 0,
                fontSize: '0.97rem',
                fontWeight: 600,
                color: 'var(--ink)',
                lineHeight: 1.35,
              }}>
                {lesson.title}
              </p>
            </div>

            {/* Arrow */}
            <span style={{
              flexShrink: 0,
              fontSize: '1.1rem',
              color: 'var(--muted)',
              paddingRight: 'var(--space-1)',
            }}>
              →
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
